// import React, { useState } from 'react';
// import './TextBox.css'; 



// const TextBox = ({ label, defaultValue = '', onChange,validators = [],error }) => {
//   const [value, setValue] = useState(defaultValue);
//   const [errors, setErrors] = useState([]);


//   const handleInputChange = (event) => {
//     const newValue = event.target.value;
  
//     // Validate on change
//     const newErrors = validators
//       .map((validator) => (typeof validator === 'function' ? validator(newValue) : null))
//       .filter((error) => typeof error === 'string');
  
//     // Set errors
//     setErrors(newErrors);
  
//     // Update state only if there are no errors
//     if (newErrors.length === 0) {
//       setValue(newValue);
//       if (onChange) {
//         onChange(event, newErrors);
//       }
//     }
//   };

//   const displayErrors = error ? [error] : errors;

//   return (
//     <div className='text-box-container fts-15 common-text ftw-4'>
//       <textarea
//         className='text-box fts-15 common-text ftw-4'
//         value={value}
//         onChange={handleInputChange}
//         placeholder=' '
//         rows={5} 
//       />
//       <label className={`text-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''}`}>{label}</label>
//       {displayErrors.length > 0 && (
//         <div className="input-error-message fts-12">
//           {displayErrors[0]}
//         </div>
//       )}
//     </div>
//   );
// };

// export default TextBox;

import React, { useState } from 'react';
import './TextBox.css'; 

const TextBox = ({ label, defaultValue = '', onChange, border='', validators = [], error }) => {
  const [value, setValue] = useState(defaultValue);
  const [errors, setErrors] = useState([]);

  const handleInputChange = (event) => {
    const newValue = event.target.value;
  
    // Always update the value state
    setValue(newValue);
    
    // Validate the new value
    const newErrors = validators
      .map((validator) => (typeof validator === 'function' ? validator(newValue) : null))
      .filter((error) => typeof error === 'string');
  
    // Set errors
    setErrors(newErrors);
  
    // Always call onChange callback
    if (onChange) {
      onChange(event, newErrors);
    }
  };

  const displayErrors = error ? [error] : errors;

  return (
    <div className='text-box-container fts-15 common-text ftw-4'>
      <textarea
        className={`text-box fts-15 common-text ftw-4 ${border}`}
        value={value}
        onChange={handleInputChange}
        placeholder=' '
        rows={5} 
      />
      <label className={`text-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''}`}>{label}</label>
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default TextBox;